export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 4;
export const THURSDAY = 8;
export const FRIDAY = 16;
export const SATURDAY = 32;
export const SUNDAY = 64;

export const weekDayNames = [
    {Id: MONDAY, Name: 'Понедельник'},
    {Id: TUESDAY, Name: 'Вторник'},
    {Id: WEDNESDAY, Name: 'Среда'},
    {Id: THURSDAY, Name: 'Четверг'},
    {Id: FRIDAY, Name: 'Пятница'},
    {Id: SATURDAY, Name: 'Суббота'},
    {Id: SUNDAY, Name: 'Воскресенье'},
];

export function toWeekDaysArray(data) {
    if (!data)
        return null;
    return weekDayNames.filter(names => (data & names.Id) == names.Id);
}

export function toFlagEnum(data) {
    if (!data)
        return null;
    return data.reduce((a, b) => a + b, 0);
}

export const days = [
        { name: 'Monday', value: MONDAY,  label: 'Понедельник' },
        { name: 'Tuesday', value: TUESDAY, label: 'Вторник' },
        { name: 'Wesnesday', value: TUESDAY,label: 'Среда' },
        { name: 'Thursday', value: WEDNESDAY, label: 'Четверг' },
        { name: 'Friday', value: THURSDAY,label: 'Пятница' },
        { name: 'Saturday', value: FRIDAY, label: 'Суббота' },
        { name: 'Sunday', value: SUNDAY,  label: 'Воскресенье' }
    ];



// WEBPACK FOOTER //
// ./src/constants/weekDays.js